<template>
  <div :class="{'slo-loader': true, 'loading': loading}">
    <slot v-if="!loading" />
    <div
      v-else
      :class="{ 'slo-loader-icon': true, [`color-${color}`]: true, [`size-${size}`]: true  }"
    >
      <SloIcon name="CircleDashed" :size="size" />
      <div v-if="message" class="message mt-md no-wrap">
        <p class="c-gray-900 text-base m-0">{{ message | t }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import t from '../../js/main/i18n';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloLoader',
  components: {
    SloIcon
  },
  filters: {
    t
  },
  props: {
    loading: {type: Boolean, default: true},
    message: {type: String, default: ''},
    color: {type: String, default: 'blue'},
    size: {type: String, default: 'lg'}
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-loader {
  .slo-loader-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-inline: auto;

    &.size-xl {
      width: 96px !important;
      height: 96px !important;
    }

    &.size-lg {
      width: 48px !important;
      height: 48px !important;
    }

    &.size-md {
      width: 22px !important;
      height: 22px !important;
    }

    &.color-blue {
      color: $color-blue-400;
    }

    &.color-white {
      color: $color-white;
    }
  }

  &.loading {
    margin-top: 0;
    margin-bottom: 0;

    .slo-icon {
      animation: spin 4s cubic-bezier(0.7, 0.09, 0.39, 1.26) infinite;

      @keyframes spin {
        0% {
          transform: rotate(180deg);
        }
        25% {
          transform: rotate(360deg);
        }
        50% {
          transform: rotate(540deg);
        }
        75% {
          transform: rotate(720deg);
        }
        100% {
          transform: rotate(900deg);
        }
      }
    }
  }
}
</style>
